import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useShop } from 'shop/hooks'
import { buildTitle } from './utils'

interface Props {
  productName?: string
}

export const PageTitle = ({ productName }: Props) => {
  const { currentPartnerStore, partner } = useShop()
  const { name: storeName = null } = currentPartnerStore || {}
  const { seo, name: partnerName = null } = partner || {}
  const { tagline = null } = seo || {}

  const [seoTitle, setSeoTitle] = useState('')

  const title = useMemo(() => {
    return buildTitle(partnerName, storeName, productName, tagline)
  }, [partnerName, storeName, tagline, productName])

  useEffect(() => {
    setSeoTitle(title)
  }, [title])

  if (!title) {
    return <></>
  }

  return (
    <Helmet>
      <title>{seoTitle}</title>
    </Helmet>
  )
}
